import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

export const Container = styled.div`
  display: inline-flex;
  gap: 8px;
  padding: 4px;
  border-radius: 8px;
  background-color: ${color.background.light};
`

export const Tab = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 36px;
  padding: 0 16px;
  border: none;
  border-radius: 8px;
  outline: none;
  font-family: ${tokens.typography.fontFamily.primary};
  font-size: 14px;
  font-weight: ${props => (props.selected ? 500 : 400)};
  color: ${props => (props.selected ? color.text.primary : color.text.secondary)};
  background-color: ${props => (props.selected ? color.background.default : 'transparent')};
  box-shadow: ${props => (props.selected ? '0 1px 2px rgba(0, 0, 0, 0.05)' : 'none')};
  cursor: ${props => (props.selected ? 'default' : 'pointer')};
  transition: all 0.2s;

  :hover {
    background-color: ${props => (props.selected ? color.background.default : 'rgba(0, 0, 0, 0.04)')};
  }

  svg {
    width: 16px;
    height: 16px;
  }
`
